(function($) {
  var PB008_CHAR_MAX = 20;      /* Yin 2026-09-16 (vorher 15) */
  var PB008_SYMBOL_COST = 3;    /* ein Motiv verbraucht 3 davon */
  var PB008_FONT = 'G02';       /* Yin 2026-09-10: nur diese eine Schrift */
  var PB008_ALLOWED_FONTS = [PB008_FONT];
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var previewSideCount = 1;
  var physicalSideMap = [0];
  var globalFont = null;
  var fontsCache = null;
  var symbolsCache = null;

  /* Basisbilder — Konvention einzel/paar (DEV-PROCESS Abschnitt 3):
       einzel = EIN Steg   -> einseitig
       paar   = ZWEI Stege -> beidseitig (links Vorderseite, rechts Rueckseite)
     Die einzel-Bilder sind aus den paar-Bildern erzeugt (scripts/pb008/bilder.py):
     rechter Steg weg, linker Steg pixelgenau an seiner Stelle. Deshalb ist der
     einzel-Steg byteidentisch mit dem linken paar-Steg — nachgemessen, und
     genau darum teilen sich die Slots 'einzel' und 'paar_links' ihre Werte. */
  var PB008_PREVIEW_IMAGES = {
    silber:         window.VIV_PB008.bild_pb008_preview_silber_paar_png,
    gold:           window.VIV_PB008.bild_pb008_preview_gold_paar_png,
    rosegold:       window.VIV_PB008.bild_pb008_preview_rosegold_paar_png,
    silberEinzel:   window.VIV_PB008.bild_pb008_preview_silber_einzel_png,
    goldEinzel:     window.VIV_PB008.bild_pb008_preview_gold_einzel_png,
    rosegoldEinzel: window.VIV_PB008.bild_pb008_preview_rosegold_einzel_png
  };

  /* ---- Lupe (Buehnenausschnitt) -----------------------------------------
     Buehne ist PB008_STAGE_ASPECT-mal so breit wie hoch; die Lupe darin ist
     quadratisch (= Bildseitenverhaeltnis) und wird per transform gezoomt.
     Rechenweg (Bildkoordinaten in % der Bildbreite, alles gemessen in
     docs/PREVIEW-UPLOAD-PB008.md):
       Gravurflaeche links   x 119–714  -> Mitte 26.03 %, Breite 37.25 %
       Gravurflaeche rechts  x 879–1475 -> Mitte 73.56 %, Breite 37.31 %
       Steg-Aussenkanten     x  70–1523 -> Spannweite 90.81 %
       Gravurflaeche y       762–830    -> Mitte 49.75 %, Hoehe 4.31 %
     einzel: 37.25 % x 2.1 = 78.2 % Buehnenbreite fuer die Gravurflaeche,
             der ganze Steg 43.3 % x 2.1 = 90.9 % — passt ohne Anschnitt.
     paar:   90.81 % x 1.05 = 95.4 % — beide Stege ganz im Bild.
     Senkrecht sichtbar: einzel (1/3)/2.1 = 15.9 % Bildhoehe um 49.75 %,
     paar (1/3)/1.05 = 31.7 % — der Steg (47.6…51.9 %) liegt in beiden drin. */
  var PB008_STAGE_ASPECT = 3;
  var PB008_VIEW = {
    "einzel": { "zoom": 2.1,  "focusX": 26.03, "focusY": 49.75 },
    "paar":   { "zoom": 1.05, "focusX": 49.80, "focusY": 49.75 }
  };

  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.
     ★ Bestand kommt jetzt aus DIESER Datei statt aus dem Template-Picker.
     ⚠️ Dateinamen unregelmaessig: w01–w10 zweistellig, ab W11 dreistellig. */
  var PB008_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz', 'w02.png': 'Herz', 'w03.png': 'Doppelherz', 'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch', 'w07.png': 'Kreuz', 'w09.png': 'Engel', 'w027.png': 'Anker',
    'w031.png': 'Pfote', 'w036.png': 'Fee', 'w041.png': 'Stern'
  };

  var PB008_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_PB008.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_PB008.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_PB008.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_PB008.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_PB008.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_PB008.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_PB008.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_PB008.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_PB008.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_PB008.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_PB008.bild_w041_png }
  ];

  /* Einzige echte Umbenennung beim Wechsel C → W. */
  var PB008_SYMBOL_ALIAS = { 'Fisch': 'Jesusfisch', 'Christenfisch': 'Jesusfisch' };

  function resolveSymbolName(name) {
    name = String(name || '').trim();
    return PB008_SYMBOL_ALIAS[name] || name;
  }

  /* =========================================================================
     TUNER-DRIVEN CONFIG — the preview render reads ONLY these variables.
     Every knob is an independent coordinate: text anchor per side, text
     adjustment per [side][font], icon override per [symbol slug].
     Calibrate via ?pb008tuner=1 and paste the exported JSON back here.
     ========================================================================= */
  /* Engraving anchor — % of stage, per [side][font]: every font sits
     differently on the band, so each font has its own anchor. Missing font
     -> PB008_TEXT_POS_BASE, never another font's anchor. (PB008 is sold
     front-only; the back entries only exist so a beidseitig variant would
     not share knobs.) */
  var PB008_TEXT_POS_BASE = { x: 26.03, y: 49.75 };
  var PB008_TEXT_POS = {
    "einzel": {
      "G02": {
        "x": 26.03,
        "y": 49.75
      }
    },
    "paar_links": {
      "G02": {
        "x": 26.03,
        "y": 49.75
      }
    },
    "paar_rechts": {
      "G02": {
        "x": 73.56,
        "y": 49.75
      }
    }
  };
  /* ---- Groessen-Dreigespann (GOTCHAS 9c: die drei gehoeren zusammen) -----
     Bezug ist die LUPE (container-type: inline-size), deren Kante genau die
     Bildbreite ist. 1 cqw = 1 % der Bildbreite = 16 px auf 1600 — unabhaengig
     vom Zoom, deshalb bleibt die Kalibrierung beim Zoomwechsel gueltig.
     Gravurflaeche: 37.25 % breit, 4.31 % hoch (gemessen).
       Basisgroesse 3.0 %  -> Versalhoehe ~ 0.7 em = 2.1 % = 48 % der Steghoehe
       Zeilenkasten dazu   ~ 4.0 %  (line-height 1.15 + Unterlaengen)
       hmax 4.2 % liegt UEBER diesen 4.0 % -> die Schranke greift erst bei
       Ausreissern, der Groessenregler bleibt lebendig (E367-Falle).
       wmax 34 % laesst 3.25 % Rand auf der 37.25 % breiten Flaeche.
     15 Zeichen à ~0.5 em ergeben ~22.5 %, mit zwei Motiven ~25.5 % — beides
     unter wmax, die Zeile wird also normalerweise nicht gestaucht. */
  var PB008_TEXT_BASE_SIZE = 3.0;
  /* Neutral max-width base, % of stage width — per-[side][font] override via
     TEXT_ADJ.wmax (missing wmax -> this base, never another font's value). */
  var PB008_TEXT_MAX_WIDTH_PCT = 34;
  /* Neutral max-HEIGHT base, % of stage (0 = no cap) — tall fonts/icons that
     exceed it shrink the whole line. Per-[side][font] override via
     TEXT_ADJ.hmax (missing hmax -> this base, never another font's value). */
  var PB008_TEXT_MAX_HEIGHT_PCT = 4.2;
  /* Per-[side][font] adjustment — size multiplier + own max width (wmax).
     Position lives in PB008_TEXT_POS[side][font] (per-font anchor). */
  var PB008_TEXT_ADJ = {
    "einzel": {
      "G02": {
        "mult": 1,
        "wmax": 34,
        "hmax": 4.2
      }
    },
    "paar_links": {
      "G02": {
        "mult": 1,
        "wmax": 34,
        "hmax": 4.2
      }
    },
    "paar_rechts": {
      "G02": {
        "mult": 1,
        "wmax": 34,
        "hmax": 4.2
      }
    }
  };
  /* Inline symbol base geometry, em relative to the text size (neutral default).
     height=size, top=up/down, gap=kerning spacing, dx=pure left/right nudge
     (visual only, does not shift following glyphs), rot=own rotation angle. */
  var PB008_ICON = {
    "height": 1,
    "top": 0,
    "gap": 0,
    "dx": 0,
    "rot": 0
  };
  /* Per-[font][symbol slug] overrides: { height, top, gap, dx, rot, opacity }.
     Every font pairs with the icons differently, so each (font, symbol)
     combination is its own independent coordinate — size, up/down, left/right,
     angle and opacity all separate. Missing key/property -> falls back to
     PB008_ICON / PB008_ENGRAVE.iconOpacity, never to another font's or another
     symbol's values. */
  var PB008_ICON_ADJ = {
    "G02": {
      "herz": {
        "top": -0.1,
        "height": 1
      },
      "mini-herz": {
        "opacity": 0.45,
        "height": 1,
        "top": -0.1
      },
      "infinity": {
        "height": 1.05,
        "top": 0,
        "dx": 0,
        "gap": 0.25
      },
      "doppelherz": {
        "gap": 0.25,
        "top": -0.1
      },
      "jesusfisch": {
        "dx": 0.25,
        "top": -0.05
      },
      "pfote": {
        "top": -0.05,
        "dx": 0,
        "height": 1.1
      },
      "anker": {
        "top": -0.05,
        "opacity": 0.45
      },
      "stern": {
        "top": -0.1
      },
      "fee": {
        "top": -0.1
      },
      "kreuz": {
        "top": -0.1
      }
    },
    "G04": {
      "mini-herz": {
        "height": 1,
        "top": -0.05
      },
      "doppelherz": {
        "dx": 0.25
      },
      "infinity": {
        "gap": 0.15,
        "opacity": 0.45
      },
      "jesusfisch": {
        "dx": 0.15,
        "opacity": 0.45
      },
      "herz": {
        "gap": 0.1
      },
      "anker": {
        "opacity": 0.45
      }
    },
    "G05": {
      "mini-herz": {
        "height": 1,
        "top": -0.05
      },
      "jesusfisch": {
        "gap": 0.15
      },
      "infinity": {
        "gap": 0.15,
        "opacity": 0.45
      },
      "doppelherz": {
        "dx": 0.15
      },
      "anker": {
        "opacity": 0.45
      }
    },
    "G06": {
      "mini-herz": {
        "top": -0.15
      },
      "infinity": {
        "gap": 0.15,
        "top": -0.1,
        "opacity": 0.45
      },
      "jesusfisch": {
        "gap": 0.15,
        "dx": 0,
        "top": -0.1
      },
      "engel": {
        "gap": 0.1,
        "top": -0.1
      },
      "pfote": {
        "top": -0.15
      },
      "anker": {
        "top": -0.1,
        "opacity": 0.45
      },
      "doppelherz": {
        "gap": 0.15,
        "top": -0.1
      },
      "herz": {
        "top": -0.1
      }
    }
  };
  /* Bangle curvature — the engraving follows the band arc. Per [side][font]:
     every font has its own independent depth/rotate/tilt (fonts differ in
     metrics, so the arc fit differs per font; adjusting one font never moves
     another). depth: rise at the stage edge, % of stage width; rotate: char
     tilt in ° at the stage edge; tilt: whole-line (text + icons together)
     rotation in ° around the anchor — positive = links ↑ / rechts ↓.
     Missing font -> PB008_CURVE_BASE, never another font's values. */
  var PB008_CURVE_BASE = {
    "depth": 0,
    "rotate": 0,
    "tilt": 0
  };
  var PB008_CURVE = {
    "einzel": {
      "G02": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      }
    },
    "paar_links": {
      "G02": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      }
    },
    "paar_rechts": {
      "G02": {
        "depth": 0,
        "rotate": 0,
        "tilt": 0
      }
    }
  };
  /* Engraved look — outlined glyphs (text-stroke) with a mostly-transparent
     fill so the metal shows through, plus a faint light catch below.
     stroke/fill are per metal (option1 colour); width/highlight/iconOpacity
     here are only the neutral base. */
  var PB008_ENGRAVE = {
    /* Yin 2026-09-16: „stelle die schrift auf normal und nicht fett ein."
       Fett wirkte sie nicht ueber font-weight (das stand immer auf 400),
       sondern ueber die Kontur: -webkit-text-stroke verdickt jeden Zug
       beidseitig, 0.7 px Kontur sehen aus wie ein fetter Schnitt. Darum
       jetzt 0 — die Glyphe zeigt ihre eigene Strichstaerke, die schwarze
       Fuellung traegt den Kontrast. Der Regler bleibt, wer wieder Kontur
       will, dreht ihn hoch. */
    "width": 0,
    "highlight": "0 0.8px 0.8px rgba(255,255,255,0.4)",
    "iconOpacity": 0.9,
    /* Yin 2026-09-16: „stelle die anzeigefarbe der zeichen auf schwarz ein".
       Vorher war die Schrift je Metall getoent (Silber grau, Gold braun,
       Rosegold rotbraun) und die Fuellung fast durchsichtig (0.22) — das las
       sich auf dem schmalen Steg zu blass. Jetzt alle drei Metalle schwarz
       mit deckender Fuellung; der Aufbau (Kontur + Fuellung + Lichtkante)
       bleibt, damit die Regler im Tuner weiter dieselben sind. */
    "silber": {
      "stroke": "rgba(0,0,0,0.92)",
      "fill": "rgba(0,0,0,0.88)"
    },
    "gold": {
      "stroke": "rgba(0,0,0,0.92)",
      "fill": "rgba(0,0,0,0.88)"
    },
    "rosegold": {
      "stroke": "rgba(0,0,0,0.92)",
      "fill": "rgba(0,0,0,0.88)"
    }
  };
  /* Per-font engrave overrides: { width, highlight } — stroke thickness and
     light catch differ per font (thin script vs. bold). Missing key/property
     -> PB008_ENGRAVE base, never another font's values. */
  var PB008_ENGRAVE_ADJ = {
    "G02": {
      "width": 0
    },
    "G04": {},
    "G05": {},
    "G06": {}
  };

  var PB008_FONT_STACK = {
    G02: 'NirmalaS, sans-serif',
    G04: '"Monotype Corsiva", sans-serif',
    G05: '"Bradley Hand ITC", sans-serif',
    G06: '"Murray Hill BT", sans-serif'
  };

  function esc(s) {
    return String(s || '').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function symbolSlug(name) {
    return String(name || '')
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker. */
  function loadSymbols() {
    if (symbolsCache) return symbolsCache;
    symbolsCache = PB008_SYMBOLS_FIXED.slice();
    return symbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE"; nur ueber den Code findet der
     Auftrags-Parser das Bild wieder. */
  function formatSymbolOrderValue(name) {
    var resolved = resolveSymbolName(name);
    if (!resolved) return '';
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Der Feldname entscheidet, ob der Parser ein Bild zeigt: "… Motiv" loest
     den Code auf, "… Text + Motiv" trennt "Text(Motiv)" selbst auf. Ein Motiv
     unter dem Label "Text" bleibt fuer immer bildlos. */
  /* Bestellzeile fuer die Werkstatt (GOTCHAS 10: einziger Konsument sind
     die Augen des Graveurs). Die Zeile geht so raus, wie sie graviert wird —
     Motive an ihrer Stelle, mit Namen (+ Code im Bestellwert), damit man
     sieht, ob das Herz VOR oder NACH dem Namen steht. */
  function symbolOrderRow(title, raw, withCode) {
    var text = lineText(raw);
    var syms = lineSymbols(raw);
    var value = String(raw || '').replace(/\(([^)]+)\)/g, function(all, name) {
      if (!getSymbolByName(name)) return all;
      return '(' + (withCode ? formatSymbolOrderValue(name) : resolveSymbolName(name)) + ')';
    });
    if (text && syms.length) return { name: title + ' Text + Motiv', value: value };
    if (syms.length)         return { name: title + ' Motiv',        value: value };
    return { name: title + ' Text', value: value };
  }

  function loadFonts() {
    if (fontsCache) return fontsCache;
    fontsCache = [];
    $('.product_info_font_json').each(function() {
      try {
        var arr = JSON.parse($(this).html());
        for (var i = 0; i < arr.length; i++) {
          if (PB008_ALLOWED_FONTS.indexOf(arr[i].font_name) !== -1) {
            fontsCache.push(arr[i]);
          }
        }
      } catch (e) {}
    });
    PB008_ALLOWED_FONTS.forEach(function(code) {
      if (!fontsCache.some(function(f) { return f.font_name === code; })) {
        fontsCache.push({ font_name: code, text: code, image: '' });
      }
    });
    fontsCache.sort(function(a, b) {
      return PB008_ALLOWED_FONTS.indexOf(a.font_name) - PB008_ALLOWED_FONTS.indexOf(b.font_name);
    });
    return fontsCache;
  }

  function getGlobalFont() {
    if (!globalFont) {
      var fonts = loadFonts();
      globalFont = fonts.length ? fonts[0] : { font_name: 'G02', text: 'NirmalaS' };
    }
    return globalFont;
  }

  function pb008FontCode(fontCode) {
    return fontCode || getGlobalFont().font_name || 'G02';
  }

  function getFontFamilyCss(fontCode) {
    var code = pb008FontCode(fontCode);
    if (PB008_FONT_STACK[code]) return PB008_FONT_STACK[code];
    var font = getGlobalFont();
    if (!fontCode && font.text) return font.text.indexOf(',') !== -1 ? font.text : font.text + ', sans-serif';
    return PB008_FONT_STACK.G02;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var symbols = loadSymbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0, re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += getSymbolByName(match[1]) ? PB008_SYMBOL_COST : match[0].length;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  /* ---- Die Zeile ------------------------------------------------------------
     Yin 2026-09-10: „一行单独文字 然后是文字加图标 … 可以加两个 也可以加一个".
     Also gibt es KEINE zwei Stilkarten und kein Motivfeld neben dem Text —
     es gibt eine einzige Zeile, und der Kunde setzt Motive frei hinein.
     Traeger ist der Rohtext des Eingabefeldes; ein Motiv steht darin als
     "(Name)". Genau diese Schreibweise lesen weightedLength (Motiv = 3
     Zeichen) und buildEngravingHtml (Motiv = Bild) schon von A104 her, beide
     mit globalem Regex — mehrere Motive konnten sie immer, nur die Eingabe
     kannte bisher genau eins. */
  var PB008_ICON_MAX = 2;

  /* Alle gueltigen Motive der Zeile, in ihrer Reihenfolge. */
  function lineSymbols(raw) {
    var out = [], re = /\(([^)]+)\)/g, m;
    while ((m = re.exec(String(raw || ''))) !== null) {
      if (getSymbolByName(m[1])) out.push(m[1]);
    }
    return out;
  }

  /* Reiner Text ohne die Motiv-Marken — fuer „steht ueberhaupt Text drin?". */
  function lineText(raw) {
    return $.trim(String(raw || '').replace(/\(([^)]+)\)/g, function(all, name) {
      return getSymbolByName(name) ? '' : all;
    }));
  }

  /* Kuerzt bis das Zeichenbudget passt, ohne eine Motiv-Marke aufzuschneiden. */
  function trimToMax(raw) {
    raw = String(raw || '');
    while (weightedLength(raw) > PB008_CHAR_MAX && raw.length) {
      var m = raw.match(/\(([^)]+)\)$/);
      if (m && getSymbolByName(m[1])) raw = raw.slice(0, -m[0].length);
      else raw = raw.slice(0, -1);
    }
    return raw;
  }

  /* Mehr als PB008_ICON_MAX Motive: die ueberzaehligen (von hinten) fallen
     raus. Greift nur, wenn jemand die Marken von Hand tippt oder einfuegt. */
  function enforceIconMax(raw) {
    raw = String(raw || '');
    var syms = lineSymbols(raw);
    while (syms.length > PB008_ICON_MAX) {
      var letzte = syms[syms.length - 1];
      var stelle = raw.lastIndexOf('(' + letzte + ')');
      if (stelle < 0) break;
      raw = raw.slice(0, stelle) + raw.slice(stelle + letzte.length + 2);
      syms = lineSymbols(raw);
    }
    return raw;
  }

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw043SetPhysicalSideMap = setPhysicalSideMap;

  function ensurePB008GravurConfig() {
    if (window.lwGravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) window.lwGravurConfig = config;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silber';
  }

  /* Zwei Textfelder im Popup = beidseitig. Der Zaehler kommt aus dem DOM des
     Popups, das die lw043-Engine aus option2 (einseitig/beidseitig) baut. */
  function isBeidseitig() {
    return getActiveSideCount() > 1;
  }

  /* einseitig zeigt das einzel-Bild, beidseitig das paar-Bild. */
  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (!isBeidseitig()) {
      return PB008_PREVIEW_IMAGES[colorKey + 'Einzel']
        || PB008_PREVIEW_IMAGES.silberEinzel;
    }
    return PB008_PREVIEW_IMAGES[colorKey] || PB008_PREVIEW_IMAGES.silber;
  }

  /* Aktueller Lupenausschnitt — haengt nur am Modus, nicht an der Seite. */
  function getView() {
    return PB008_VIEW[isBeidseitig() ? 'paar' : 'einzel'] || PB008_VIEW.einzel;
  }

  /* Lupe setzen: Brennpunkt in die Buehnenmitte schieben, dann zoomen.
     translate-% beziehen sich auf die Lupe selbst (quadratisch, Kante =
     Buehnenbreite): waagerecht ist die Buehnenmitte 50 %, senkrecht
     50/ASPECT %, weil die Buehne nur 1/ASPECT so hoch wie breit ist. */
  function applyPreviewView() {
    var v = getView();
    var $view = $('[data-pb008-preview-stage] .pb008-preview-view');
    if (!$view.length) return;
    var tx = 50 - v.focusX;
    var ty = (50 / PB008_STAGE_ASPECT) - v.focusY;
    $view.css({
      'transform-origin': v.focusX + '% ' + v.focusY + '%',
      'transform': 'translate(' + tx + '%, ' + ty + '%) scale(' + v.zoom + ')'
    });
  }


  // ---- Zugriff auf die Seiten-Container des Popups ----
  /* ---- KOORDINATEN (GPS → GMS) & RÖMISCHE ZAHLEN --------------------------
     Ported from A184 (product-a184-personalization.liquid). Both modes render
     one single line in a fixed font (G02) through PB008's own engraved-look
     pipeline. Bei PB008 ist das ohnehin die einzige Schrift. Self-contained, pb008- prefixed. */
  var PB008_FIXED_MODE_FONT = 'G02';
  var PB008_ROMAN_MAX = 20; // max characters the customer may type for the date
  // --- Geocoding via Google Maps (Geocoder aus der Maps JavaScript API).
  //     Publishable Browser-Key; Referrer-Beschraenkung liegt in der Google
  //     Cloud Console (viviannaschmuck.de + myshopify-Preview). ---
  var PB008_GEOCODE_API_KEY = 'AIzaSyAghNIu6qTkOQQxFf8oMQQgg9E_QsHzSeU';
  var PB008_GEOCODE_ENDPOINT = 'https://maps.googleapis.com/maps/api/js';
  var PB008_GEOCODE_STATICMAP = 'https://maps.googleapis.com/maps/api/staticmap';


  function toRoman(num) {
    num = parseInt(num, 10);
    if (!num || num < 1 || num > 3999) return '';
    var map = [[1000,'M'],[900,'CM'],[500,'D'],[400,'CD'],[100,'C'],[90,'XC'],[50,'L'],[40,'XL'],[10,'X'],[9,'IX'],[5,'V'],[4,'IV'],[1,'I']];
    var out = '';
    for (var i = 0; i < map.length; i++) {
      while (num >= map[i][0]) { out += map[i][1]; num -= map[i][0]; }
    }
    return out;
  }

  function romanDateResult(raw) {
    raw = String(raw || '').trim();
    var parts = raw ? raw.split(/[.\-\/\s]+/) : [];
    var out = [], anyBad = false, anyGood = false;
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var r = toRoman(parts[i]);
      if (r) { out.push(r); anyGood = true; }
      else { anyBad = true; }
    }
    return { text: out.join(' · '), anyBad: anyBad, anyGood: anyGood };
  }

  function formatRomanDate(raw) {
    return romanDateResult(raw).text;
  }

  function toGMS(dec, isLat) {
    if (dec == null || isNaN(dec)) return '';
    var dir = isLat ? (dec >= 0 ? 'N' : 'S') : (dec >= 0 ? 'E' : 'W');
    var a = Math.abs(dec);
    var d = Math.floor(a);
    var mf = (a - d) * 60;
    var m = Math.floor(mf);
    var s = Math.round((mf - m) * 60 * 10) / 10;
    if (s >= 60) { s -= 60; m += 1; }
    if (m >= 60) { m -= 60; d += 1; }
    var mm = (m < 10 ? '0' : '') + m;
    var ss = (s < 10 ? '0' : '') + s.toFixed(1);
    return d + '°' + mm + "'" + ss + '"' + dir;
  }

  function loadGoogleMapsApi(onReady, onFail) {
    if (window.google && window.google.maps && window.google.maps.Geocoder) { onReady(); return; }
    var q = (window.__vivGmapsCallbacks = window.__vivGmapsCallbacks || []);
    q.push({ ok: onReady, fail: onFail });
    if (window.__vivGmapsLoading) return;
    window.__vivGmapsLoading = true;
    window.__vivGmapsReady = function() {
      var cb;
      while ((cb = q.shift())) { try { cb.ok(); } catch (e) {} }
    };
    var s = document.createElement('script');
    s.src = PB008_GEOCODE_ENDPOINT + '?key=' + encodeURIComponent(PB008_GEOCODE_API_KEY) +
      '&v=weekly&language=de&region=DE&loading=async&callback=__vivGmapsReady';
    s.async = true;
    s.onerror = function() {
      window.__vivGmapsLoading = false;
      var cb;
      while ((cb = q.shift())) { try { cb.fail(); } catch (e) {} }
    };
    document.head.appendChild(s);
  }

  function geocodeAddress(address, onOk, onErr) {
    if (!PB008_GEOCODE_API_KEY) { onErr('no-key'); return; }
    loadGoogleMapsApi(function() {
      try {
        new window.google.maps.Geocoder().geocode({ address: address, region: 'DE' }, function(results, status) {
          if (status === 'OK' && results && results.length) {
            var loc = results[0].geometry.location;
            onOk(loc.lat(), loc.lng(), results[0].formatted_address || '');
          } else if (status === 'ZERO_RESULTS') { onErr('not-found'); }
          else { onErr('network'); }
        });
      } catch (e) { onErr('network'); }
    }, function() { onErr('network'); });
  }

  function buildStaticMapUrl(lat, lng) {
    if (!PB008_GEOCODE_API_KEY) return '';
    return PB008_GEOCODE_STATICMAP + '?key=' + encodeURIComponent(PB008_GEOCODE_API_KEY) +
      '&center=' + lat + ',' + lng + '&zoom=16&size=600x260&format=png&language=de' +
      '&markers=color:red%7C' + lat + ',' + lng;
  }

  function getSideEl(sideIndex) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
  }
  function getSideMode(sideIndex) {
    return getSideEl(sideIndex).attr('data-pb008-mode') || 'freitext';
  }
  function getSideKoordGms(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.pb008-koord-gms').val() || '');
  }
  function getSideKoordAddress(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.pb008-koord-address').val() ||
      getSideEl(sideIndex).find('.pb008-koord-input').val() || '');
  }
  function getKoordText(sideIndex) {
    var gms = getSideKoordGms(sideIndex);
    if (!gms) return '';
    var p = gms.split('|');
    return $.trim((p[0] || '') + ' ' + (p[1] || ''));
  }
  function getSideRomanRaw(sideIndex) {
    return $.trim(getSideEl(sideIndex).find('.pb008-roman-input').val() || '');
  }
  function getRomanText(sideIndex) {
    return formatRomanDate(getSideRomanRaw(sideIndex));
  }


  function updateFontGridVisibility() {
    var anyFixed = false;
    $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').each(function() {
      if (($(this).attr('data-pb008-mode') || 'freitext') !== 'freitext') anyFixed = true;
    });
    $('.up-Fenster-p-personalization-1 .pb008-global-font').css('display', anyFixed ? 'none' : '');
  }



  function getLineInput(sideIndex) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex)
      .find('.pb008-line-input');
  }

  function getSideData(sideIndex) {
    var raw = String(getLineInput(sideIndex).val() || '');
    return { raw: raw, text: lineText(raw), symbols: lineSymbols(raw) };
  }

  function sideHasContent(sideIndex) {
    var mode = getSideMode(sideIndex);
    if (mode === 'koordinaten') return !!getKoordText(sideIndex);
    if (mode === 'roemische_zahlen') return !!getRomanText(sideIndex);
    return !!$.trim(getSideData(sideIndex).raw);
  }

  function toggleLineClear($input, value) {
    var hasContent = !!(value && String(value).trim());
    $input.siblings('.pb008-line-clear').css('display', hasContent ? 'block' : 'none');
  }

  function updateLineCounter($input) {
    var len = weightedLength($input.val() || '');
    $input.closest('.pb008-line-input-wrap').find('.pb008-line-counter')
      .html('<span class="pb008-count">' + len + '</span> / ' + PB008_CHAR_MAX);
    toggleLineClear($input, $input.val());
  }

  /* Zaehlt, wie oft jedes Motiv in der Zeile steht — dasselbe darf zweimal
     drin sein, deshalb reicht „markiert / nicht markiert" nicht mehr. */
  function symbolAnzahlen(raw) {
    var zaehler = {};
    lineSymbols(raw).forEach(function(n) { zaehler[n] = (zaehler[n] || 0) + 1; });
    return zaehler;
  }

  function syncSymbolGridForSide(sideIndex) {
    var zaehler = symbolAnzahlen(getLineInput(sideIndex).val() || '');
    var $grid = $('.product_info_main_' + sideIndex).find('.pb008-symbol-grid');
    $grid.find('button').each(function() {
      var n = zaehler[$(this).attr('data-symbol')] || 0;
      $(this).toggleClass('is-active', n > 0);
      var $zahl = $(this).find('.pb008-symbol-anzahl');
      if (n > 1) {
        if (!$zahl.length) $zahl = $('<span class="pb008-symbol-anzahl"></span>').prependTo(this);
        $zahl.text(n);
      } else if ($zahl.length) {
        $zahl.remove();
      }
    });
  }

  function applyFontToInputs() {
    var fontCode = getGlobalFont().font_name || 'G02';
    $('.up-Fenster-p-personalization-1 .pb008-line-input')
      .attr('data-pb008-font', fontCode)
      .css('font-family', getFontFamilyCss());
  }

  /* ---------------------------- preview render ---------------------------- */

  /* ---- Slots ------------------------------------------------------------
     Ein Slot ist EIN Steg in EINEM Modus — die Zahl der Slots ist also
     Modi x Stege je Modus (TUNER-PATTERN), nicht "Vorderseite/Rueckseite":
       einzel       einseitig, der eine Steg
       paar_links   beidseitig, linker Steg  = Vorderseite
       paar_rechts  beidseitig, rechter Steg = Rueckseite
     Slotnamen duerfen nirgends in einen Closure eingefroren werden — sonst
     schreiben Regler nach einem Moduswechsel still in den alten Slot
     (SOP Phase 2.5, A183-Regression). */
  var PB008_SLOTS = ['einzel', 'paar_links', 'paar_rechts'];

  function getSideKey(physicalSide) {
    if (!isBeidseitig()) return 'einzel';
    return physicalSide === 1 ? 'paar_rechts' : 'paar_links';
  }

  function slotLabel(slot) {
    if (slot === 'paar_rechts') return 'Rückseite (rechts)';
    if (slot === 'paar_links') return 'Vorderseite (links)';
    return 'Vorderseite (einseitig)';
  }

  function getTextAdj(sideKey, fontCode) {
    var code = pb008FontCode(fontCode);
    return (PB008_TEXT_ADJ[sideKey] || {})[code] || { mult: 1 };
  }

  function getTextPos(sideKey, fontCode) {
    var code = pb008FontCode(fontCode);
    return (PB008_TEXT_POS[sideKey] || {})[code] || PB008_TEXT_POS_BASE;
  }

  function getIconGeom(slug, fontCode) {
    var font = pb008FontCode(fontCode);
    var o = (PB008_ICON_ADJ[font] || {})[slug] || {};
    return {
      height: o.height != null ? o.height : PB008_ICON.height,
      top: o.top != null ? o.top : PB008_ICON.top,
      gap: o.gap != null ? o.gap : PB008_ICON.gap,
      dx: o.dx != null ? o.dx : (PB008_ICON.dx || 0),
      rot: o.rot != null ? o.rot : (PB008_ICON.rot || 0),
      opacity: o.opacity != null ? o.opacity : PB008_ENGRAVE.iconOpacity
    };
  }

  function getCurve(sideKey, fontCode) {
    var font = pb008FontCode(fontCode);
    return (PB008_CURVE[sideKey] || {})[font] || PB008_CURVE_BASE;
  }

  function getEngraveAdj(fontCode) {
    var font = pb008FontCode(fontCode);
    return PB008_ENGRAVE_ADJ[font] || {};
  }

  function getEngraveWidth(fontCode) {
    var a = getEngraveAdj(fontCode);
    return a.width != null ? a.width : PB008_ENGRAVE.width;
  }

  function getEngraveHighlight(fontCode) {
    var a = getEngraveAdj(fontCode);
    return a.highlight != null ? a.highlight : PB008_ENGRAVE.highlight;
  }

  function getMaxWidthPct(sideKey, fontCode) {
    var adj = getTextAdj(sideKey, fontCode);
    return adj.wmax != null ? adj.wmax : PB008_TEXT_MAX_WIDTH_PCT;
  }

  function getMaxHeightPct(sideKey, fontCode) {
    var adj = getTextAdj(sideKey, fontCode);
    return adj.hmax != null ? adj.hmax : PB008_TEXT_MAX_HEIGHT_PCT;
  }

  function charSpans(text) {
    var html = '';
    for (var i = 0; i < text.length; i++) {
      html += '<span class="pb008-ch">' + esc(text.charAt(i)) + '</span>';
    }
    return html;
  }

  function buildEngravingHtml(raw, fontCode) {
    if (!raw) return '';
    var html = '', re = /\(([^)]+)\)/g, last = 0, match;
    while ((match = re.exec(raw)) !== null) {
      if (match.index > last) html += charSpans(raw.substring(last, match.index));
      var sym = getSymbolByName(match[1]);
      if (sym && sym.image) {
        var g = getIconGeom(symbolSlug(sym.text), fontCode);
        html += '<img class="pb008-preview-symbol pb008-preview-symbol--' + esc(symbolSlug(sym.text)) + '"' +
          ' data-pb008-dx="' + g.dx + '" data-pb008-rot="' + g.rot + '"' +
          ' style="height:' + g.height + 'em;position:relative;top:' + g.top + 'em;margin-left:' + g.gap + 'em;vertical-align:middle;' +
          'opacity:' + g.opacity + ';"' +
          ' src="' + esc(sym.image) + '" alt="' + esc(match[1]) + '">';
      } else {
        html += charSpans('(' + match[1] + ')');
      }
      last = re.lastIndex;
    }
    if (last < raw.length) html += charSpans(raw.substring(last));
    return html;
  }

  /* Shift + tilt every char/icon along a parabola fixed in stage space so the
     engraving hugs the bangle arc. `scale` is the fit-to-width factor already
     applied to the line, so the arc stays in visual (post-scale) coordinates. */
  function applyPB008Curve(el, scale, stageW) {
    var sideKey = el.getAttribute('data-pb008-side') || 'einzel';
    var fontCode = el.getAttribute('data-pb008-font-code') || undefined;
    var curve = getCurve(sideKey, fontCode);
    var depthPx = (curve.depth || 0) / 100 * stageW;
    var halfStage = stageW / 2;
    var mid = el.scrollWidth / 2;
    var kids = el.querySelectorAll('.pb008-ch, img');
    for (var i = 0; i < kids.length; i++) {
      var k = kids[i];
      var dxLayout = (k.offsetLeft + k.offsetWidth / 2) - mid;
      var t = halfStage > 0 ? (dxLayout * scale) / halfStage : 0;
      var dyVis = -depthPx * t * t;
      var dyLayout = scale > 0 ? dyVis / scale : dyVis;
      var angle = -(curve.rotate || 0) * t;
      // Per-icon own left/right nudge (dx, em) + own rotation (rot, °),
      // composed with the arc's shift/tilt. Text chars have neither.
      var iconDx = 0, iconRot = 0;
      if (k.tagName === 'IMG') {
        iconDx = parseFloat(k.getAttribute('data-pb008-dx')) || 0;
        iconRot = parseFloat(k.getAttribute('data-pb008-rot')) || 0;
      }
      k.style.transform = 'translateY(' + dyLayout + 'px)' +
        (iconDx ? ' translateX(' + iconDx + 'em)' : '') +
        ' rotate(' + (angle + iconRot) + 'deg)';
    }
  }

  function fitPreviewTextWidths() {
    /* Bezugsbreite ist die LUPE (= Bildbreite im Layout, vor transform).
       clientWidth ignoriert transform, deshalb sind alle %-Konstanten hier
       Bildkoordinaten und vom Zoom unabhaengig. */
    var stage = $('[data-pb008-preview-stage] .pb008-preview-view')[0];
    if (!stage || !stage.clientWidth) return;
    var stageW = stage.clientWidth;
    $('[data-pb008-preview-stage] .pb008-preview-view .pb008-preview-text').each(function() {
      var sideKey = this.getAttribute('data-pb008-side') || 'einzel';
      var fontCode = this.getAttribute('data-pb008-font-code') || undefined;
      var maxW = stageW * (getMaxWidthPct(sideKey, fontCode) / 100);
      var maxH = stageW * (getMaxHeightPct(sideKey, fontCode) / 100);
      var tilt = getCurve(sideKey, fontCode).tilt || 0;
      var tiltCss = tilt ? ' rotate(' + tilt + 'deg)' : '';
      this.style.transform = 'translate(-50%, -50%)' + tiltCss;
      var w = this.scrollWidth;
      var h = this.scrollHeight;
      var scale = 1;
      if (w > 0 && maxW > 0 && w > maxW) {
        scale = maxW / w;
      }
      if (maxH > 0 && h > 0 && h * scale > maxH) {
        scale = maxH / h;
      }
      if (scale !== 1) {
        this.style.transform = 'translate(-50%, -50%) scale(' + scale + ')' + tiltCss;
      }
      applyPB008Curve(this, scale, stageW);
    });
  }

  function scheduleFitPreviewTextWidths() {
    requestAnimationFrame(function() {
      fitPreviewTextWidths();
      requestAnimationFrame(fitPreviewTextWidths);
    });
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-pb008-preview-stage] .pb008-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();
    var metal = PB008_ENGRAVE[getColorKeyFromOption1()] || PB008_ENGRAVE.silber;

    for (var i = 0; i < zu; i++) {
      var mode = getSideMode(i);
      var raw, fc;
      if (mode === 'koordinaten') { raw = getKoordText(i); fc = PB008_FIXED_MODE_FONT; }
      else if (mode === 'roemische_zahlen') { raw = getRomanText(i); fc = PB008_FIXED_MODE_FONT; }
      else {
        raw = getSideData(i).raw;
        fc = getGlobalFont().font_name || PB008_FONT;
      }
      if (!$.trim(raw)) continue;
      var fcl = String(fc).toLowerCase();
      var sideKey = getSideKey(getPhysicalSideIndex(i));
      var pos = getTextPos(sideKey, fc);
      var adj = getTextAdj(sideKey, fc);
      var style =
        'left:' + pos.x + '%;' +
        'top:' + pos.y + '%;' +
        'font-size:calc(' + PB008_TEXT_BASE_SIZE + 'cqw * ' + (adj.mult != null ? adj.mult : 1) + ');' +
        'color:' + metal.fill + ';' +
        '-webkit-text-stroke:' + getEngraveWidth(fc) + 'px ' + metal.stroke + ';' +
        (getEngraveHighlight(fc) && getEngraveHighlight(fc) !== 'none'
          ? 'text-shadow:' + getEngraveHighlight(fc) + ';' : '') +
        'font-family:' + getFontFamilyCss(fc) + ';';
      $layers.append(
        '<div class="pb008-preview-text pb008-preview-font-' + fcl + '" data-pb008-side="' + sideKey + '" data-pb008-font-code="' + fc + '" style="' + style + '">' +
        buildEngravingHtml(raw, fc) + '</div>'
      );
    }
    scheduleFitPreviewTextWidths();
    $layers.find('.pb008-preview-text img').off('load.pb008Fit').on('load.pb008Fit', fitPreviewTextWidths);
    if ($layers.find('.pb008-preview-text img').filter(function() { return this.complete; }).length) {
      fitPreviewTextWidths();
    }
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;
    if (!$host.find('.pb008-preview-wrap').length) {
      $host.prepend(
        '<div class="pb008-preview-wrap">' +
          '<div class="pb008-preview-label">Vorschau</div>' +
          '<div class="pb008-preview-stage" data-pb008-preview-stage>' +
            /* Lupe: quadratisch wie das Bild, per transform auf den Steg
               gezoomt. Basisbild UND Gravurebenen liegen darin, damit die
               Anker Bildkoordinaten bleiben und der Zoom sie mitnimmt. */
            '<div class="pb008-preview-view" data-pb008-preview-view>' +
              '<img class="pb008-preview-base" alt="">' +
              '<div class="pb008-preview-layers"></div>' +
            '</div>' +
          '</div>' +
        '</div>'
      );
    }
    if (!$host.find('.pb008-global-font').length) {
      $host.find('.pb008-preview-wrap').after(
        '<div class="pb008-global-font">' +
          '<div class="pb008-global-font-label">Schriftart</div>' +
          '<div class="pb008-font-grid" data-pb008-font-grid></div>' +
        '</div>'
      );
      renderFontGrid();
    }
  }

  function renderFontGrid() {
    var fonts = loadFonts();
    var current = getGlobalFont();
    var html = '';
    for (var i = 0; i < fonts.length; i++) {
      var f = fonts[i];
      var active = f.font_name === current.font_name;
      var gname = String(f.font_name || '');
      // [2] Probetext = der Schriftname selbst, in dieser Schrift (Yin 2026-08-15)
      html += '<button type="button" class="pb008-font-zeile' + (active ? ' is-active' : '') + '" data-font="' + esc(gname) + '" data-family="' + esc(f.text) + '" data-value="' + esc(gname) + '">' +
        '<span class="pb008-font-probe" style="font-family:' + esc(f.text) + ';">' + esc(gname) + '</span>' +
        '<span class="pb008-font-code">' + esc(gname) + '</span>' +
        '<span class="pb008-font-haken">&#10003;</span>' +
      '</button>';
    }
    $('[data-pb008-font-grid]').html(html);
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadSymbols();
    var drin = lineSymbols(getLineInput(sideIndex).val() || '');
    var html = '<div class="pb008-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = drin.indexOf(sym.text) !== -1 ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="pb008-symbol-label">' + esc(sym.text) + '</span></button>';
    }
    return html + '</div>';
  }


  function buildKoordPanel(sideIndex) {
    return '<div class="pb008-mode-panel" data-mode-panel="koordinaten" data-side="' + sideIndex + '" style="display:none">' +
      '<div class="pb008-line-label">Adresse / Ort</div>' +
      '<div class="pb008-koord-row">' +
        '<input type="text" class="pb008-koord-input" placeholder="z. B. Marienplatz 1, München" autocomplete="off">' +
        '<button type="button" class="pb008-koord-btn">Suchen</button>' +
      '</div>' +
      '<div class="pb008-koord-status" aria-live="polite"></div>' +
      '<div class="pb008-koord-result" style="display:none">' +
        '<div class="pb008-koord-found"></div>' +
        '<img class="pb008-koord-map" alt="Karte" loading="lazy" onerror="this.style.display=\'none\'">' +
        '<div class="pb008-koord-confirm-row">' +
          '<button type="button" class="pb008-koord-confirm">Übernehmen</button>' +
          '<span class="pb008-koord-gmshint"></span>' +
        '</div>' +
      '</div>' +
      '<input type="hidden" class="pb008-koord-gms">' +
      '<input type="hidden" class="pb008-koord-address">' +
      '<input type="hidden" class="pb008-koord-pending-gms">' +
      '<input type="hidden" class="pb008-koord-pending-address">' +
    '</div>';
  }

  function buildRomanPanel(sideIndex) {
    return '<div class="pb008-mode-panel" data-mode-panel="roemische_zahlen" data-side="' + sideIndex + '" style="display:none">' +
      '<div class="pb008-line-label">Datum</div>' +
      '<div class="pb008-line-input-wrap">' +
        '<input type="text" class="pb008-roman-input" maxlength="' + PB008_ROMAN_MAX + '" data-maxlen="' + PB008_ROMAN_MAX + '" placeholder="TT.MM.JJJJ" autocomplete="off">' +
      '</div>' +
      '<span class="pb008-char-hint">z. B. 28.12.2024 → XXVIII · XII · MMXXIV · max. ' + PB008_ROMAN_MAX + ' Zeichen</span>' +
      '<div class="pb008-roman-status" aria-live="polite"></div>' +
    '</div>';
  }


  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;
    $side.find('.pattles-tab-header').hide();

    if (!$side.find('.pb008-mode-switch').length) {
      $side.attr('data-pb008-mode', 'freitext');
      $side.find('.pattles-message-header').after(
        /* Drei Gravurarten je Seite (Yin 2026-09-15). Die data-mode-Werte sind
           dieselben wie bei A104 — getSideMode, Speicherstand und
           Bestellausgabe haengen daran. Bei beidseitig waehlt JEDE Seite ihre
           Art selbst, weil der Modus am Seiten-Container haengt. */
        '<div class="pb008-mode-switch" data-side="' + sideIndex + '">' +
          '<button type="button" class="is-active" data-mode="freitext"><span class="pb008-layout-name">Text</span><span class="pb008-layout-sub">z.B. ein Name</span></button>' +
          '<button type="button" data-mode="koordinaten"><span class="pb008-layout-name">Koordinaten</span><span class="pb008-layout-sub">GPS als Gravur</span></button>' +
          '<button type="button" data-mode="roemische_zahlen"><span class="pb008-layout-name">Römische Zahlen</span><span class="pb008-layout-sub">Datum in Ziffern</span></button>' +
        '</div>' +
        '<div class="pb008-mode-panel" data-mode-panel="freitext" data-side="' + sideIndex + '">' +
          '<div class="pb008-line-block">' +
            '<div class="pb008-line-label">Gravur</div>' +
            '<div class="pb008-line-input-wrap">' +
              '<input type="text" class="pb008-line-input" data-side="' + sideIndex + '" data-max="' + PB008_CHAR_MAX + '">' +
              '<div class="pb008-line-clear" style="display:none"></div>' +
              '<span class="pb008-line-counter"><span class="pb008-count">0</span> / ' + PB008_CHAR_MAX + '</span>' +
            '</div>' +
            buildSymbolGrid(sideIndex) +
          '</div>' +
        '</div>' +
        buildKoordPanel(sideIndex) +
        buildRomanPanel(sideIndex) +
        '<p class="pb008-side-error">Bitte fülle die Gravur für diese Seite aus.</p>'
      );
    }
    updateLineCounter(getLineInput(sideIndex));
    /* [2] Kontext-Schriftart: der Schrift-Block wandert IN das Freitext-Panel
       (ueber die Textzeile). Bleibt derselbe Knoten — getGlobalFont, Restore
       und Bestellausgabe lesen ihn unveraendert. */
    var $gf = $('.up-Fenster-p-personalization-1 .pb008-global-font');
    var $frei = $side.find('.pb008-mode-panel[data-mode-panel="freitext"]');
    if ($gf.length && $frei.length && !$frei.find('.pb008-global-font').length) $frei.prepend($gf);
    updateFontGridVisibility();
  }

  window.pb008UpdatePreview = function() {
    ensurePreviewShell();
    $('[data-pb008-preview-stage] .pb008-preview-base').attr('src', getColorPreviewUrl());
    applyPreviewView();
    renderAllPreviewEngravings();
    if (window.__pb008RefreshTuner) window.__pb008RefreshTuner();
  };

  function bindEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.off('click.pb008Font', '[data-pb008-font-grid] button').on('click.pb008Font', '[data-pb008-font-grid] button', function() {
      globalFont = { font_name: $(this).data('font'), text: $(this).data('family') };
      $('[data-pb008-font-grid] button').removeClass('is-active');
      $(this).addClass('is-active');
      applyFontToInputs();
      $('.up-Fenster-p-personalization-1 .pb008-line-input').each(function() {
        updateLineCounter($(this));
      });
      window.pb008UpdatePreview();
    });

    $popup.off('input.pb008Line', '.pb008-line-input').on('input.pb008Line', '.pb008-line-input', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      var roh = trimToMax(enforceIconMax(($input.val() || '').replace(/[\r\n]/g, '')));
      if (roh !== $input.val()) $input.val(roh);
      toggleLineClear($input, roh);
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.pb008UpdatePreview();
    });

    /* Motivraster = EINSETZEN, immer. Auch dasselbe Motiv ein zweites Mal
       (Yin 2026-09-16: „dass dasselbe symbol zweimal ausgewählt werden kann").
       Bis 2026-09-16 nahm ein zweiter Klick das Motiv wieder heraus — genau
       das stand dem „zweimal dasselbe" im Weg. Weggenommen wird jetzt ueber
       die Zeile selbst: Rueckschritt direkt hinter einer Motivmarke loescht
       sie als Ganzes (siehe keydown.pb008Line unten), und das Kreuz raeumt
       die ganze Zeile. Die Zahl am Motiv zeigt, wie oft es drin ist. */
    $popup.off('click.pb008Symbol', '.pb008-symbol-grid button').on('click.pb008Symbol', '.pb008-symbol-grid button', function() {
      var $grid = $(this).closest('.pb008-symbol-grid');
      var idx = parseInt($grid.attr('data-side'), 10);
      var symName = String($(this).data('symbol') || '');
      var $input = getLineInput(idx);
      var roh = String($input.val() || '');
      var marke = '(' + symName + ')';

      if (lineSymbols(roh).length >= PB008_ICON_MAX) return;
      if (weightedLength(roh + marke) > PB008_CHAR_MAX) return;
      roh = roh + marke;

      $input.val(roh);
      toggleLineClear($input, roh);
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.pb008UpdatePreview();
    });

    /* Eine Motivmarke ist im Feld sechs bis zwoelf Zeichen lang ("(Herz)").
       Ohne diese Zeile muesste der Kunde sie Zeichen fuer Zeichen wegloeschen
       — und zwischendrin steht Unsinn wie "(Her". Rueckschritt direkt hinter
       einer vollstaendigen Marke nimmt sie deshalb als Ganzes weg. */
    $popup.off('keydown.pb008Marke', '.pb008-line-input').on('keydown.pb008Marke', '.pb008-line-input', function(e) {
      if (e.key !== 'Backspace' && e.keyCode !== 8) return;
      var el = this;
      if (el.selectionStart == null || el.selectionStart !== el.selectionEnd) return;
      var pos = el.selectionStart;
      var treffer = String(el.value).slice(0, pos).match(/\(([^)]+)\)$/);
      if (!treffer || !getSymbolByName(treffer[1])) return;
      e.preventDefault();
      var neuPos = pos - treffer[0].length;
      el.value = el.value.slice(0, neuPos) + el.value.slice(pos);
      try { el.setSelectionRange(neuPos, neuPos); } catch (err) {}
      $(el).trigger('input');
    });

    $popup.off('click.pb008Clear', '.pb008-line-clear').on('click.pb008Clear', '.pb008-line-clear', function() {
      var $input = $(this).siblings('.pb008-line-input');
      var idx = getSideIndexFromEl($input);
      $input.val('');
      toggleLineClear($input, '');
      syncSymbolGridForSide(idx);
      updateLineCounter($input);
      window.pb008UpdatePreview();
    });

    // ---- mode switch: Freitext / Koordinaten / Römische Zahlen ----
    $popup.off('click.pb008Mode', '.pb008-mode-switch button').on('click.pb008Mode', '.pb008-mode-switch button', function() {
      var $btn = $(this);
      var idx = parseInt($btn.closest('.pb008-mode-switch').attr('data-side'), 10);
      var mode = $btn.attr('data-mode');
      $btn.addClass('is-active').siblings().removeClass('is-active');
      var $side = $('.product_info_main_' + idx);
      $side.attr('data-pb008-mode', mode);
      $side.find('.pb008-mode-panel').hide();
      $side.find('.pb008-mode-panel[data-mode-panel="' + mode + '"]').show();
      updateFontGridVisibility();
      window.pb008UpdatePreview();
    });

    // ---- RÖMISCHE ZAHLEN: cap length, warn out-of-range, live conversion ----
    $popup.off('input.pb008Roman', '.pb008-roman-input').on('input.pb008Roman', '.pb008-roman-input', function() {
      if (this.value.length > PB008_ROMAN_MAX) this.value = this.value.slice(0, PB008_ROMAN_MAX);
      var res = romanDateResult(this.value);
      var $st = $(this).closest('.pb008-mode-panel[data-mode-panel="roemische_zahlen"]').find('.pb008-roman-status');
      if (res.anyBad && !res.anyGood) $st.text('Bitte ein gültiges Datum eingeben (Zahlen 1–3999).');
      else if (res.anyBad) $st.text('Ein Wert ist zu groß – römische Zahlen gehen nur bis 3999.');
      else $st.text('');
      window.pb008UpdatePreview();
    });
    $popup.off('keydown.pb008Roman', '.pb008-roman-input').on('keydown.pb008Roman', '.pb008-roman-input', function(e) {
      if (e.key === 'Enter') e.preventDefault();
    });

    // ---- KOORDINATEN: geocode → verify address + map → Übernehmen ----
    $popup.off('keydown.pb008KoordIn', '.pb008-koord-input').on('keydown.pb008KoordIn', '.pb008-koord-input', function(e) {
      if (e.key === 'Enter') { e.preventDefault(); $(this).closest('.pb008-mode-panel').find('.pb008-koord-btn').trigger('click'); }
    });
    $popup.off('click.pb008KoordBtn', '.pb008-koord-btn').on('click.pb008KoordBtn', '.pb008-koord-btn', function() {
      var $panel = $(this).closest('.pb008-mode-panel[data-mode-panel="koordinaten"]');
      var addr = $.trim($panel.find('.pb008-koord-input').val() || '');
      var $status = $panel.find('.pb008-koord-status');
      var $result = $panel.find('.pb008-koord-result');
      $result.hide();
      if (addr.length < 3) { $status.text('Bitte gib eine vollständige Adresse ein.'); return; }
      $status.text('Suche…');
      geocodeAddress(addr, function(lat, lng, disp) {
        var latStr = toGMS(lat, true), lngStr = toGMS(lng, false);
        $panel.find('.pb008-koord-pending-gms').val(latStr + '|' + lngStr);
        $panel.find('.pb008-koord-pending-address').val(disp || addr);
        $panel.find('.pb008-koord-found').text(disp || addr);
        $panel.find('.pb008-koord-gmshint').text(latStr + '  ·  ' + lngStr);
        var mapUrl = buildStaticMapUrl(lat, lng);
        var $map = $panel.find('.pb008-koord-map');
        if (mapUrl) { $map.attr('src', mapUrl).css('display', ''); } else { $map.hide(); }
        $status.text('Stimmt der Ort? Dann auf „Übernehmen".');
        $result.show();
      }, function(err) {
        $status.text(
          err === 'no-key' ? 'Koordinaten-Suche noch nicht konfiguriert.' :
          err === 'not-found' ? 'Adresse nicht gefunden – bitte genauer angeben.' :
          'Suche fehlgeschlagen – bitte erneut versuchen.'
        );
      });
    });
    $popup.off('click.pb008KoordConfirm', '.pb008-koord-confirm').on('click.pb008KoordConfirm', '.pb008-koord-confirm', function() {
      var $panel = $(this).closest('.pb008-mode-panel[data-mode-panel="koordinaten"]');
      var pg = $.trim($panel.find('.pb008-koord-pending-gms').val() || '');
      if (!pg) return;
      $panel.find('.pb008-koord-gms').val(pg);
      $panel.find('.pb008-koord-address').val($.trim($panel.find('.pb008-koord-pending-address').val() || ''));
      $panel.find('.pb008-koord-status').text('✓ Ort übernommen.');
      window.pb008UpdatePreview();
    });

    if (!window._pb008PreviewFitResize) {
      window._pb008PreviewFitResize = true;
      $(window).on('resize.pb008PreviewFit', fitPreviewTextWidths);
    }
  }

  /* --------------------- popup engine hooks (lw043 family) --------------------- */

  window.lw043ValidateBeforeOpen = function() {
    return true;
  };

  window.lw043AfterUpdateSize = function(zu) {
    ensurePB008GravurConfig();
    var gravurConfig = window.lwGravurConfig;
    if (gravurConfig && gravurConfig.physicalSides) {
      setPhysicalSideMap(gravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) return;
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) setupSide(i);
    renderFontGrid();
    applyFontToInputs();
    bindEvents();
    window.pb008UpdatePreview();
  };

  window.lw043OnPopupOpen = function() {
    symbolsCache = null;
    fontsCache = null;
    if (window.lw043RefreshPopupSides) lw043RefreshPopupSides();
    ensurePreviewShell();
    previewSideCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length || previewSideCount;
    if (window.lw043AfterUpdateSize) lw043AfterUpdateSize(previewSideCount);
    else { bindEvents(); window.pb008UpdatePreview(); }
    buildPB008Tuner();
  };

  window.lw043OnPopupClose = function() {
    $('.product-info--lw043 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.lw043ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      $side.removeClass('has-error');
      $side.find('.pb008-side-error').hide();
      if (!sideHasContent(i)) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.pb008-side-error').show();
      }
    }
    if (!valid) {
      alert('Bitte fülle die Gravur aus.');
      /* [6] Fokus-Regel: den (roten) Kopf der Problemseite anspringen. */
      var $kopf = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"].has-error').first();
      var scrollEl = $('.up-Fenster-p-personalization-1').find('.fenster-content-inner, .fenster-content-contentin').get(0);
      if ($kopf.length && scrollEl) {
        scrollEl.scrollTop = Math.max(0, $kopf[0].getBoundingClientRect().top - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 8);
      }
    }
    return valid;
  };

  window.lw043AppendSideProperties = function(properies_arr, zu, popup_title) {
    var fontName = getGlobalFont().font_name;
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var mode = getSideMode(i);
      if (mode === 'koordinaten') {
        var gms = getSideKoordGms(i);
        var koordOut = gms ? gms.replace('|', ' / ') : '';
        if (koordOut) {
          properies_arr.push([title + ' KOORDINATEN', koordOut]);
          var addr = getSideKoordAddress(i);
          if (addr) properies_arr.push([title + ' KOORDINATEN Adresse', addr]);
          properies_arr.push([title + ' KOORDINATEN Font', PB008_FIXED_MODE_FONT]);
        }
        continue;
      }
      if (mode === 'roemische_zahlen') {
        var romanRaw = getSideRomanRaw(i);
        var romanOut = formatRomanDate(romanRaw);
        if (romanOut) {
          properies_arr.push([title + ' RÖMISCHE ZAHLEN', romanOut]);
          if (romanRaw) properies_arr.push([title + ' RÖMISCHE ZAHLEN Datum', romanRaw]);
          properies_arr.push([title + ' RÖMISCHE ZAHLEN Font', PB008_FIXED_MODE_FONT]);
        }
        continue;
      }
      var d = getSideData(i);
      var orderRow = symbolOrderRow(title, d.raw, true);
      if ($.trim(orderRow.value)) {
        properies_arr.push([orderRow.name, orderRow.value]);
        if (d.text) properies_arr.push([title + ' Font', fontName]);
      }
    }
  };

  window.lw043ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';
    var fontName = getGlobalFont().font_name;

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }
      var mode = getSideMode(i);
      if (mode === 'koordinaten') {
        var gms = getSideKoordGms(i);
        var koordOut = gms ? gms.replace('|', ' / ') : '';
        if (koordOut) {
          html += template.replaceAll('{option_name}', title + ' KOORDINATEN').replaceAll('{option_value}', koordOut);
          var addr = getSideKoordAddress(i);
          if (addr) html += template.replaceAll('{option_name}', title + ' Adresse').replaceAll('{option_value}', addr);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', PB008_FIXED_MODE_FONT);
        }
        continue;
      }
      if (mode === 'roemische_zahlen') {
        var romanOut = getRomanText(i);
        if (romanOut) {
          html += template.replaceAll('{option_name}', title + ' RÖMISCHE ZAHLEN').replaceAll('{option_value}', romanOut);
          html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', PB008_FIXED_MODE_FONT);
        }
        continue;
      }
      var d = getSideData(i);
      var composed = $.trim(d.raw);
      if (composed) {
        var confirmRow = symbolOrderRow(title, d.raw, false);
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
        if (d.text) html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', fontName);
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt per DOM-Klon
         NACH dem Einhaengen der Bestaetigungsseite (pb008EnhanceConfirmOptions). */
      html = '<div class="pb008-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen: klont die live gerenderte Buehne aus dem Popup.
     ⚠ Messfalle: beim Bestaetigen ist das Popup zu (Buehne 0px) — darum
     unsichtbar messbar machen (fixed, -9999px), rendern, klonen, zurueck. */
  function pb008FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .pb008-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;
    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.pb008UpdatePreview();
    var $stage = $('[data-pb008-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var ZIEL_B = Math.max(64, Math.min(160, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="pb008-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="pb008-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      $ziel.append($('<div class="pb008-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="pb008-cv-name">' +
          (isBeidseitig() ? 'Vorderseite (links) · Rückseite (rechts)' : 'Vorderseite') +
          '</div>'));
    }
    $popup.attr('style', altStyle);
  }

  window.pb008EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(pb008FillConfirmVorschau, 0);
  };

  $(document).on('change.pb008Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.pb008UpdatePreview();
  });
  $(document).on('change.pb008GravurOption', '[name="option2"]', function() {
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) window.pb008UpdatePreview();
  });

  /* ------------------------------- PB008 tuner ------------------------------- */

  function pb008TunerEnabled() {
    try {
      return /pb008tuner/.test(String(window.location.search) + String(window.location.hash));
    } catch (e) { return false; }
  }

  function buildPB008Tuner() {
    if (!pb008TunerEnabled() || document.getElementById('pb008-tuner')) return;
    if (!window.__pb008TunerSide) window.__pb008TunerSide = 'front';

    /* Der Regler schreibt IMMER in den Slot, den die Buehne gerade zeigt.
       Der Slotname wird bei jedem Zugriff neu bestimmt und nirgends in einen
       Closure eingefroren — sonst landen Werte nach einem Wechsel von
       einseitig auf beidseitig lautlos im falschen Slot (SOP Phase 2.5). */
    function tunerSide() {
      if (!isBeidseitig()) return 'einzel';
      return (window.__pb008TunerSide === 'back') ? 'paar_rechts' : 'paar_links';
    }
    function tunerSideIndex() {
      return tunerSide() === 'paar_rechts' ? 1 : 0;
    }
    function tunerModus() {
      return isBeidseitig() ? 'paar' : 'einzel';
    }

    // one <input> per knob, with its own listener so typing never loses focus
    function makeRow(item) {
      if (item.h) { var hh = document.createElement('h5'); hh.textContent = item.h; return hh; }
      var row = document.createElement('div'); row.className = 'kt-row';
      var lab = document.createElement('label'); lab.textContent = item.label; lab.title = item.label;
      var inp = document.createElement('input');
      if (item.type === 'text') {
        inp.type = 'text';
        inp.value = item.get() || '';
        inp.addEventListener('input', function() {
          item.set(inp.value); window.pb008UpdatePreview();
        });
      } else {
        inp.type = 'number'; inp.step = item.step || 0.5;
        var v = item.get(); inp.value = (v == null ? '' : v);
        inp.addEventListener('input', function() {
          var n = parseFloat(inp.value);
          if (!isNaN(n)) { item.set(n); window.pb008UpdatePreview(); }
        });
      }
      row.appendChild(lab); row.appendChild(inp);
      return row;
    }
    function renderInto(box, items) {
      box.innerHTML = '';
      for (var i = 0; i < items.length; i++) box.appendChild(makeRow(items[i]));
    }

    function staticItems() {
      var it = [];
      var sk = tunerSide();
      /* Lupe — je Modus eigene Werte. Der Modus wird bei jedem get/set neu
         gelesen, nie eingefroren. */
      it.push({ h: 'Lupe · ' + (isBeidseitig() ? 'beidseitig (paar)' : 'einseitig (einzel)') });
      it.push({ label: 'Zoom ×', step: 0.05,
        get: function() { return PB008_VIEW[tunerModus()].zoom; },
        set: function(v) { PB008_VIEW[tunerModus()].zoom = v; } });
      it.push({ label: 'Brennpunkt ↔ X %', step: 0.25,
        get: function() { return PB008_VIEW[tunerModus()].focusX; },
        set: function(v) { PB008_VIEW[tunerModus()].focusX = v; } });
      it.push({ label: 'Brennpunkt ↕ Y %', step: 0.25,
        get: function() { return PB008_VIEW[tunerModus()].focusY; },
        set: function(v) { PB008_VIEW[tunerModus()].focusY = v; } });
      it.push({ h: 'Global · Basiswerte (Fallback)' });
      it.push({ label: 'Text-Basisgröße cqw', step: 0.1, get: function() { return PB008_TEXT_BASE_SIZE; }, set: function(v) { PB008_TEXT_BASE_SIZE = v; } });
      it.push({ label: 'Breite max % (Basis)', step: 1, get: function() { return PB008_TEXT_MAX_WIDTH_PCT; }, set: function(v) { PB008_TEXT_MAX_WIDTH_PCT = v; } });
      it.push({ label: 'Höhe max % Basis (0=aus)', step: 0.5, get: function() { return PB008_TEXT_MAX_HEIGHT_PCT; }, set: function(v) { PB008_TEXT_MAX_HEIGHT_PCT = v; } });
      it.push({ h: 'Text-Größe × pro Font (' + slotLabel(sk) + ')' });
      PB008_ALLOWED_FONTS.forEach(function(fontCode) {
        function ensureFontAdj() {
          var s = (PB008_TEXT_ADJ[sk] = PB008_TEXT_ADJ[sk] || {});
          return (s[fontCode] = s[fontCode] || { mult: 1 });
        }
        it.push({
          label: fontCode + ' Größe ×', step: 0.02,
          get: function() {
            var a = (PB008_TEXT_ADJ[sk] || {})[fontCode] || {};
            return a.mult != null ? a.mult : 1;
          },
          set: function(v) { ensureFontAdj().mult = v; }
        });
      });
      it.push({ h: 'Gravur-Farben (pro Metall)' });
      it.push({ label: 'Silber Kontur', type: 'text', get: function() { return PB008_ENGRAVE.silber.stroke; }, set: function(v) { PB008_ENGRAVE.silber.stroke = v; } });
      it.push({ label: 'Silber Füllung', type: 'text', get: function() { return PB008_ENGRAVE.silber.fill; }, set: function(v) { PB008_ENGRAVE.silber.fill = v; } });
      it.push({ label: 'Gold Kontur', type: 'text', get: function() { return PB008_ENGRAVE.gold.stroke; }, set: function(v) { PB008_ENGRAVE.gold.stroke = v; } });
      it.push({ label: 'Gold Füllung', type: 'text', get: function() { return PB008_ENGRAVE.gold.fill; }, set: function(v) { PB008_ENGRAVE.gold.fill = v; } });
      it.push({ label: 'Roségold Kontur', type: 'text', get: function() { return PB008_ENGRAVE.rosegold.stroke; }, set: function(v) { PB008_ENGRAVE.rosegold.stroke = v; } });
      it.push({ label: 'Roségold Füllung', type: 'text', get: function() { return PB008_ENGRAVE.rosegold.fill; }, set: function(v) { PB008_ENGRAVE.rosegold.fill = v; } });
      it.push({ h: 'Icon · Basis em (Fallback)' });
      it.push({ label: 'Icon Höhe', step: 0.05, get: function() { return PB008_ICON.height; }, set: function(v) { PB008_ICON.height = v; } });
      it.push({ label: 'Icon ↕ top', step: 0.05, get: function() { return PB008_ICON.top; }, set: function(v) { PB008_ICON.top = v; } });
      it.push({ label: 'Icon ↔ gap', step: 0.05, get: function() { return PB008_ICON.gap; }, set: function(v) { PB008_ICON.gap = v; } });
      it.push({ label: 'Icon Opacity (Basis)', step: 0.05, get: function() { return PB008_ENGRAVE.iconOpacity; }, set: function(v) { PB008_ENGRAVE.iconOpacity = v; } });
      return it;
    }

    function currentSymbolSlug() {
      var d = getSideData(tunerSideIndex());
      return d.symbols.length ? symbolSlug(d.symbols[0]) : '';
    }

    function contextKey() {
      return tunerSide() + '|' + getGlobalFont().font_name + '|' + currentSymbolSlug();
    }

    function contextItems() {
      var it = [];
      var sk = tunerSide();
      var font = getGlobalFont().font_name;
      function ensureAdj() {
        var s = (PB008_TEXT_ADJ[sk] = PB008_TEXT_ADJ[sk] || {});
        return (s[font] = s[font] || { mult: 1 });
      }
      function adj() { return (PB008_TEXT_ADJ[sk] || {})[font] || {}; }
      function ensurePos() {
        var s = (PB008_TEXT_POS[sk] = PB008_TEXT_POS[sk] || {});
        return (s[font] = s[font] || { x: PB008_TEXT_POS_BASE.x, y: PB008_TEXT_POS_BASE.y });
      }
      function posOf() { return (PB008_TEXT_POS[sk] || {})[font] || PB008_TEXT_POS_BASE; }
      it.push({ h: 'Font: ' + font + ' (' + slotLabel(sk) + ')' });
      it.push({ label: 'Anker ↔ X %', step: 0.5, get: function() { return posOf().x; }, set: function(v) { ensurePos().x = v; } });
      it.push({ label: 'Anker ↕ Y %', step: 0.5, get: function() { return posOf().y; }, set: function(v) { ensurePos().y = v; } });
      it.push({ label: 'Text-Größe ×', step: 0.02, get: function() { var a = adj(); return a.mult != null ? a.mult : 1; }, set: function(v) { ensureAdj().mult = v; } });
      it.push({ label: 'Breite max %', step: 1, get: function() { var a = adj(); return a.wmax != null ? a.wmax : PB008_TEXT_MAX_WIDTH_PCT; }, set: function(v) { ensureAdj().wmax = v; } });
      it.push({ label: 'Höhe max % (0=aus)', step: 0.5, get: function() { var a = adj(); return a.hmax != null ? a.hmax : PB008_TEXT_MAX_HEIGHT_PCT; }, set: function(v) { ensureAdj().hmax = v; } });

      function ensureCurve() {
        var s = (PB008_CURVE[sk] = PB008_CURVE[sk] || {});
        return (s[font] = s[font] || { depth: PB008_CURVE_BASE.depth, rotate: PB008_CURVE_BASE.rotate, tilt: PB008_CURVE_BASE.tilt });
      }
      function curve() { return (PB008_CURVE[sk] || {})[font] || PB008_CURVE_BASE; }
      it.push({ h: 'Bogen · ' + font + ' (' + slotLabel(sk) + ')' });
      it.push({ label: 'Bogen Tiefe % (Ränder ↑)', step: 0.2, get: function() { return curve().depth; }, set: function(v) { ensureCurve().depth = v; } });
      it.push({ label: 'Bogen Rotation °', step: 0.5, get: function() { return curve().rotate; }, set: function(v) { ensureCurve().rotate = v; } });
      it.push({ label: 'Neigung ° ganze Zeile (+ links↑)', step: 0.5, get: function() { return curve().tilt || 0; }, set: function(v) { ensureCurve().tilt = v; } });

      function ensureEng() { return (PB008_ENGRAVE_ADJ[font] = PB008_ENGRAVE_ADJ[font] || {}); }
      function eng() { return PB008_ENGRAVE_ADJ[font] || {}; }
      it.push({ h: 'Gravur-Stil · ' + font });
      it.push({ label: 'Kontur-Breite px', step: 0.05, get: function() { var e = eng(); return e.width != null ? e.width : PB008_ENGRAVE.width; }, set: function(v) { ensureEng().width = v; } });
      it.push({ label: 'Highlight (text-shadow)', type: 'text', get: function() { var e = eng(); return e.highlight != null ? e.highlight : PB008_ENGRAVE.highlight; }, set: function(v) { ensureEng().highlight = v; } });

      var slug = currentSymbolSlug();
      if (slug) {
        function ensureIcon() {
          var f = (PB008_ICON_ADJ[font] = PB008_ICON_ADJ[font] || {});
          return (f[slug] = f[slug] || {});
        }
        function icon() { return (PB008_ICON_ADJ[font] || {})[slug] || {}; }
        it.push({ h: 'Motiv: ' + slug + ' · Font ' + font });
        it.push({ label: 'Icon Höhe (em)', step: 0.05, get: function() { var o = icon(); return o.height != null ? o.height : PB008_ICON.height; }, set: function(v) { ensureIcon().height = v; } });
        it.push({ label: 'Icon ↕ top (em)', step: 0.05, get: function() { var o = icon(); return o.top != null ? o.top : PB008_ICON.top; }, set: function(v) { ensureIcon().top = v; } });
        it.push({ label: 'Icon ↔ X (em)', step: 0.05, get: function() { var o = icon(); return o.dx != null ? o.dx : (PB008_ICON.dx || 0); }, set: function(v) { ensureIcon().dx = v; } });
        it.push({ label: 'Icon ↔ gap/Abstand (em)', step: 0.05, get: function() { var o = icon(); return o.gap != null ? o.gap : PB008_ICON.gap; }, set: function(v) { ensureIcon().gap = v; } });
        it.push({ label: 'Icon Winkel °', step: 1, get: function() { var o = icon(); return o.rot != null ? o.rot : (PB008_ICON.rot || 0); }, set: function(v) { ensureIcon().rot = v; } });
        it.push({ label: 'Icon Opacity', step: 0.05, get: function() { var o = icon(); return o.opacity != null ? o.opacity : PB008_ENGRAVE.iconOpacity; }, set: function(v) { ensureIcon().opacity = v; } });
      }

      // Always-visible per-symbol size list for the CURRENT font — every
      // (font, symbol) height is its own independent value.
      it.push({ h: 'Icon-Größe pro Motiv · ' + font });
      loadSymbols().forEach(function(sym) {
        var symSlug = symbolSlug(sym.text);
        it.push({
          label: sym.text + ' Höhe', step: 0.05,
          get: function() {
            var o = (PB008_ICON_ADJ[font] || {})[symSlug] || {};
            return o.height != null ? o.height : PB008_ICON.height;
          },
          set: function(v) {
            var f = (PB008_ICON_ADJ[font] = PB008_ICON_ADJ[font] || {});
            (f[symSlug] = f[symSlug] || {}).height = v;
          }
        });
      });
      return it;
    }

    var el = document.createElement('div');
    el.id = 'pb008-tuner';
    el.innerHTML =
      '<div class="kt-title">PB008 Tuner</div>' +
      '<div class="kt-side" id="pb008-kt-side" style="display:none">' +
        '<button type="button" data-side="front" class="is-active">Vorne (links)</button>' +
        '<button type="button" data-side="back">Hinten (rechts)</button>' +
      '</div>' +
      '<div id="pb008-kt-static"></div>' +
      '<h5 style="color:#c4a574">▼ Kontext (folgt Popup-Auswahl)</h5>' +
      '<div id="pb008-kt-context"></div>' +
      '<div class="kt-foot"><textarea readonly></textarea>' +
        '<button type="button" data-pb008-copy>Alle Werte anzeigen &amp; kopieren</button></div>';
    document.body.appendChild(el);

    var staticBox = el.querySelector('#pb008-kt-static');
    renderInto(staticBox, staticItems());

    var ctxBox = el.querySelector('#pb008-kt-context');
    var lastKey = null, lastStaticSide = tunerSide();
    function refresh() {
      var sideTog = el.querySelector('#pb008-kt-side');
      if (sideTog) sideTog.style.display = getActiveSideCount() > 1 ? 'flex' : 'none';
      if (tunerSide() !== lastStaticSide) { lastStaticSide = tunerSide(); renderInto(staticBox, staticItems()); }
      var key = contextKey();
      if (key === lastKey) return;
      lastKey = key;
      renderInto(ctxBox, contextItems());
    }
    window.__pb008RefreshTuner = refresh;

    el.querySelectorAll('#pb008-kt-side button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        window.__pb008TunerSide = btn.getAttribute('data-side');
        el.querySelectorAll('#pb008-kt-side button').forEach(function(b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        lastKey = null; refresh();
      });
    });

    el.querySelector('[data-pb008-copy]').addEventListener('click', function() {
      var ta = el.querySelector('textarea');
      ta.style.display = 'block';
      ta.value = JSON.stringify({
        VIEW: PB008_VIEW,
        TEXT_POS: PB008_TEXT_POS,
        TEXT_BASE_SIZE: PB008_TEXT_BASE_SIZE,
        TEXT_MAX_WIDTH_PCT: PB008_TEXT_MAX_WIDTH_PCT,
        TEXT_MAX_HEIGHT_PCT: PB008_TEXT_MAX_HEIGHT_PCT,
        TEXT_ADJ: PB008_TEXT_ADJ,
        CURVE: PB008_CURVE,
        ENGRAVE: PB008_ENGRAVE,
        ENGRAVE_ADJ: PB008_ENGRAVE_ADJ,
        ICON: PB008_ICON,
        ICON_ADJ: PB008_ICON_ADJ
      }, null, 1);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
    });

    refresh();
  }

  $(function() {
    buildPB008Tuner();
  });
})(jQuery);
